const updateCartCount = (count) => {
  const cartCountEl = document.querySelector('[data-cart-count]');
  if (!cartCountEl) return;
  cartCountEl.textContent = count;
};

export default updateCartCount;
